document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initTilt();
  initContador();
  initGaleriaProducto();
  initSelectorVariantes();
  initBarraFlotanteCarrito();
  initCitasProducto();
  initGaleriaMultimedia();
  initAgregarAlCarritoAjax();
});

function initReveal() {
  var els = document.querySelectorAll('.ep-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('ep-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-ep-delay') || 0;
        setTimeout(function () { entry.target.classList.add('ep-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initTilt() {
  var cards = document.querySelectorAll('.ep-tilt');
  if (!cards.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (px * 8) + 'deg) rotateX(' + (py * -8) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () { card.style.transform = ''; });
  });
}

function initContador() {
  var nums = document.querySelectorAll('.ep-contador');
  if (!nums.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-objetivo') || '0');
      var decimales = (el.getAttribute('data-objetivo') || '').includes('.') ? 1 : 0;
      var duracion = 1400;
      var inicio = null;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = target.toFixed(decimales);
        obs.unobserve(el);
        return;
      }
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var facil = 1 - Math.pow(1 - progreso, 3);
        el.textContent = (target * facil).toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.6 });
  nums.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-ep-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-ep-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-ep-miniatura]');
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-src');
      var srcset = mini.getAttribute('data-srcset');
      if (!src || !principal) return;
      principal.src = src;
      if (srcset) principal.srcset = srcset;
      miniaturas.forEach(function (m) { m.classList.remove('ep-miniatura--activa'); });
      mini.classList.add('ep-miniatura--activa');
    });
  });
}

function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-ep-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-ep-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-ep-opcion]');
    var inputId = form.querySelector('[data-ep-input-id]');
    var precioEl = form.querySelector('[data-ep-precio]');
    var compareEl = form.querySelector('[data-ep-precio-comparado]');
    var boton = form.querySelector('[data-ep-boton-comprar]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function actualizar() {
      if (!selects.length) return;
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      inputId.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      var precioStickyEl = document.querySelector('[data-ep-precio-sticky]');
      if (precioStickyEl) precioStickyEl.textContent = moneda(variante.price);
      if (compareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          compareEl.textContent = moneda(variante.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        boton.textContent = variante.available ? boton.getAttribute('data-texto-disponible') : boton.getAttribute('data-texto-agotado');
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function initBarraFlotanteCarrito() {
  var barra = document.querySelector('[data-ep-sticky-carrito]');
  var botonReal = document.querySelector('[data-ep-boton-comprar]');
  var botonSticky = document.querySelector('[data-ep-boton-sticky]');
  if (!barra || !botonReal || !botonSticky) return;

  botonSticky.addEventListener('click', function () {
    botonReal.click();
  });

  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        barra.classList.remove('ep-sticky-visible');
      } else if (entry.boundingClientRect.top < 0) {
        barra.classList.add('ep-sticky-visible');
      } else {
        barra.classList.remove('ep-sticky-visible');
      }
    });
  }, { threshold: 0 });
  observer.observe(botonReal);
}

function initCitasProducto() {
  var contenedor = document.querySelector('[data-ep-citas]');
  if (!contenedor) return;

  var track = contenedor.querySelector('[data-ep-citas-track]');
  var slides = Array.prototype.slice.call(contenedor.querySelectorAll('[data-ep-cita]'));
  var puntos = Array.prototype.slice.call(contenedor.querySelectorAll('[data-ep-citas-punto]'));
  var btnPrev = contenedor.querySelector('[data-ep-citas-prev]');
  var btnNext = contenedor.querySelector('[data-ep-citas-next]');
  if (!track || slides.length === 0) return;

  function irA(indice) {
    indice = Math.max(0, Math.min(indice, slides.length - 1));
    track.scrollTo({ left: indice * track.clientWidth, behavior: 'smooth' });
  }

  function indiceActual() {
    var ancho = track.clientWidth || 1;
    return Math.round(track.scrollLeft / ancho);
  }

  function actualizarPuntos() {
    var actual = indiceActual();
    puntos.forEach(function (punto, i) {
      punto.classList.toggle('ep-punto--activo', i === actual);
    });
  }

  if (btnPrev) btnPrev.addEventListener('click', function () { irA(indiceActual() - 1); });
  if (btnNext) btnNext.addEventListener('click', function () { irA(indiceActual() + 1); });
  puntos.forEach(function (punto, i) {
    punto.addEventListener('click', function () { irA(i); });
  });

  var scrollTimeout;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(actualizarPuntos, 100);
  });
}

function initGaleriaMultimedia() {
  var contenedor = document.querySelector('[data-ep-galeria-multimedia]');
  if (!contenedor) return;

  var track = contenedor.querySelector('[data-ep-galeria-track]');
  var slides = Array.prototype.slice.call(contenedor.querySelectorAll('[data-ep-galeria-item]'));
  var puntos = Array.prototype.slice.call(contenedor.querySelectorAll('[data-ep-galeria-punto]'));
  var btnPrev = contenedor.querySelector('[data-ep-galeria-prev]');
  var btnNext = contenedor.querySelector('[data-ep-galeria-next]');
  if (!track || slides.length === 0) return;

  function paso() {
    var estilo = getComputedStyle(track);
    var gap = parseFloat(estilo.columnGap || estilo.gap || 0) || 0;
    return slides[0].getBoundingClientRect().width + gap;
  }

  function indiceActual() {
    var avance = paso() || 1;
    return Math.round(track.scrollLeft / avance);
  }

  function irA(indice) {
    indice = Math.max(0, Math.min(indice, slides.length - 1));
    track.scrollTo({ left: indice * paso(), behavior: 'smooth' });
  }

  function actualizarPuntos() {
    var actual = indiceActual();
    puntos.forEach(function (punto, i) {
      punto.classList.toggle('ep-punto--activo', i === actual);
    });
  }

  if (btnPrev) btnPrev.addEventListener('click', function () { irA(indiceActual() - 1); });
  if (btnNext) btnNext.addEventListener('click', function () { irA(indiceActual() + 1); });
  puntos.forEach(function (punto, i) {
    punto.addEventListener('click', function () { irA(i); });
  });

  var scrollTimeout2;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout2);
    scrollTimeout2 = setTimeout(actualizarPuntos, 100);
  });
}

function initAgregarAlCarritoAjax() {
  var formularios = document.querySelectorAll('[data-ep-form-producto]');
  if (!formularios.length) return;

  formularios.forEach(function (form) {
    form.addEventListener('submit', function (evento) {
      evento.preventDefault();

      var boton = form.querySelector('[data-ep-boton-comprar]');
      var textoOriginal = boton ? boton.textContent : '';
      if (boton) {
        boton.disabled = true;
        boton.textContent = 'Wird hinzugefügt...';
      }

      var datos = new FormData(form);
      datos.append('sections', 'cart-drawer,cart-icon-bubble');
      datos.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: datos
      })
        .then(function (respuesta) { return respuesta.json(); })
        .then(function (data) {
          if (data.status) {
            alert(data.description || data.message || 'Das Produkt konnte nicht in den Warenkorb gelegt werden.');
            return;
          }
          var cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer || !data.sections) {
            window.location.href = '/cart';
            return;
          }
          // El carrito puede haber cargado la página estando vacío (clase "is-empty" en
          // <cart-drawer>), lo que oculta la cabecera/artículos por CSS aunque el contenido
          // ya se haya actualizado. Hay que quitar esa clase al añadir el primer producto.
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else if (window.customElements && typeof customElements.whenDefined === 'function') {
            // El componente cart-drawer aún no ha terminado de cargar su script (conexión lenta):
            // esperamos a que esté listo en vez de abrir un carrito vacío.
            customElements.whenDefined('cart-drawer').then(function () {
              var drawerListo = document.querySelector('cart-drawer');
              if (drawerListo.classList.contains('is-empty')) drawerListo.classList.remove('is-empty');
              drawerListo.renderContents(data);
            });
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (boton) {
            boton.disabled = false;
            boton.textContent = textoOriginal;
          }
        });
    });
  });
}
